import React from 'react';
import Icon from '../../../components/AppIcon';

const PaymentMethodSelector = ({ selectedMethod, onMethodChange }) => {
  const paymentMethods = [
    { 
      id: 'card', 
      label: 'Credit/Debit Card', 
      icon: 'CreditCard',
      description: 'Visa, Mastercard, American Express'
    },
    { 
      id: 'vipps', 
      label: 'Vipps', 
      icon: 'Smartphone',
      description: 'Norwegian mobile payment'
    },
    { 
      id: 'paypal', 
      label: 'PayPal', 
      icon: 'Wallet',
      description: 'Pay with your PayPal account'
    },
    { 
      id: 'klarna', 
      label: 'Klarna', 
      icon: 'Building2',
      description: 'Buy now, pay later'
    }
  ];

  return (
    <div className="mb-6">
      <h4 className="text-sm font-medium text-foreground mb-4">Payment Method</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {paymentMethods?.map((method) => (
          <button
            key={method?.id}
            onClick={() => onMethodChange(method?.id)}
            className={`p-4 rounded-lg border-2 transition-all text-left ${
              selectedMethod === method?.id
                ? 'border-primary bg-primary/5 shadow-elevation'
                : 'border-border hover:border-muted-foreground/50 hover:bg-muted/30'
            }`}
          >
            <div className="flex items-center space-x-3">
              <div className={`p-2 rounded-lg ${
                selectedMethod === method?.id
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground'
              }`}>
                <Icon name={method?.icon} size={20} />
              </div>
              <div className="flex-1">
                <div className="font-medium text-foreground text-sm">{method?.label}</div>
                <div className="text-xs text-muted-foreground">{method?.description}</div>
              </div>
              {selectedMethod === method?.id && (
                <Icon name="Check" size={16} className="text-primary" />
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PaymentMethodSelector;